import {routerActions} from 'react-router-redux';

export const updateViewAllDateRange = (newDates, pathName, queryParams) =>

    dispatch => {

        queryParams.postingDateFrom = newDates.postingDateFrom;
        queryParams.postingDateTo = newDates.postingDateTo;

        const queryArray = [];

        Object.entries(queryParams).forEach(([key, value]) => {

            queryArray.push(`${key}=${value}`);

        });

        const reimbursementSummaryRoute = `${pathName}?${queryArray.join('&')}`;

        dispatch(routerActions.push(reimbursementSummaryRoute));

    };




// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/action-creators/selected-view-all-date-range.js